/**
 * Date strings for participant case note <input type="date"> using the browser timezone.
 */

const YMD_PREFIX = /^\d{4}-\d{2}-\d{2}/;

export function getClientLocalDateString(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) {
    return getClientLocalDateString(new Date());
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Map API / stored values to YYYY-MM-DD for date inputs without UTC day shift. */
export function toCaseNoteDateInputValue(value) {
  if (value == null || value === "") {
    return getClientLocalDateString();
  }
  const s = String(value).trim();
  if (YMD_PREFIX.test(s)) {
    return s.slice(0, 10);
  }
  return getClientLocalDateString(new Date(s));
}
